import { useState } from "react";
import { Link } from "react-router-dom";
import Logo from "../assets/images/home.svg";
import { FaBarsStaggered, FaFacebook } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";
import { FaInstagram } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { FaTiktok } from "react-icons/fa";
const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const openMenu = () => setIsMenuOpen(true);
  const closeMenu = () => setIsMenuOpen(false);
  return (
    <>
      <div className={`navbarr ${isMenuOpen ? "open" : ""}`}>
        <div className="navbar-logo">
          <Link to="/">
            <img className="logo" src={Logo} alt="logo" />
            <h2 className="logo-text">Söder Renovering</h2>
          </Link>
        </div>
        <div
          id="sidemenu"
          className={`navbar-left ${isMenuOpen ? "active-menu" : ""}`}
        >
          <button className="close-btn" onClick={closeMenu}>
            <IoClose />
          </button>

          <Link className="nav-link" to="/">
            Hem
          </Link>

          <Link className="nav-link" to="/services">
            Tjänster{" "}
          </Link>
          <Link className="nav-link" to="/contact">
            Kontakt{" "}
          </Link>
          <Link className="nav-link" to="/about">
            Om oss{" "}
          </Link>
        </div>
        <div className="nav-right">
          <Link
            className="nav-right-icons"
            target="_blank"
            to="https://www.facebook.com/profile.php?id=100095169007059"
          >
            <FaFacebook />
          </Link>
          <Link
            className="nav-right-icons"
            target="_blank"
            to="https://www.instagram.com/soderrenovering/"
          >
            <FaInstagram />
          </Link>

          <Link
            className="nav-right-icons"
            target="_blank"
            to="https://www.tiktok.com/@soderrenovering?is_from_webapp=1&sender_device=pc"
          >
            <FaTiktok />
          </Link>

          <button className="open-nav" onClick={openMenu}>
            <FaBarsStaggered />
          </button>
        </div>
      </div>
    </>
  );
};

export default Navbar;
